import { MWTodosModel } from 'src/main-workflow/mw.models';

export function parseTodosData(response): MWTodosModel {
  try {
    // The backend appends a trailing `{ restock_tasks: [...] }` element to the
    // to-dos array (only when there are attached restock orders). Pull it out by
    // key so the fixed room/instructions offsets below stay correct.
    const restockElement = response?.find(item => item && Array.isArray(item.restock_tasks));
    const restockTasks = restockElement?.restock_tasks ?? [];
    const withoutRestock = restockElement ? response.filter(item => item !== restockElement) : response;
    const length = withoutRestock?.length;

    const rooms = withoutRestock.slice(0, length - 2);
    const instructions = withoutRestock[length - 1];
    const parsedRooms = parseRooms(rooms);

    return {
      onLeave: instructions?.instructions?.on_leave ?? '',
      rooms: parsedRooms,
      allRoomsAreEmpty: allRoomsAreEmpty(parsedRooms),
      restockTasks
    };
  } catch (e) {
    return {
      onLeave: '',
      rooms: [],
      allRoomsAreEmpty: true,
      restockTasks: []
    }
  }
}

function parseRooms(rooms): any[] {
  const onlyRoomObjects = rooms?.filter(item => {
    return item?.address_room || item?.address_task_group;
  });
  return onlyRoomObjects.map((item) => {
    const room = item?.address_room || item?.address_task_group;
    return {
      id: room?.id,
      name: room?.name,
      category: room?.category,
      photo_notes: room?.photo_notes,
      tasks: parseTodoItems(item),
      estimated_time: item?.estimated_time
    };
  });
}

function parseTodoItems(item): any[] {
  return item?.room_tasks?.filter(taskFilter).map( todoItem => ({
    job_task_id: todoItem?.assigned_job_task?.id,
    photo_notes: todoItem?.address_task?.photo_notes,
    title: todoItem?.address_task?.title,
    important: todoItem?.address_task?.important,
    note: todoItem?.address_task?.note,
    task_end_time: '',
    origin: todoItem,
    performance: 'not_performed',
    options: todoItem.assigned_job_task.options,
    assigned_job_task_options: todoItem?.assigned_job_task_options
  })) || [];
}

function taskFilter(task: any): boolean {
  return task?.address_task?.task_type !== 'take_before_photo'
    && task?.address_task?.task_type !== 'take_after_photo'
    && task?.address_task?.task_type !== 'take_before_video'
    && task?.address_task?.task_type !== 'take_after_video';
}

function allRoomsAreEmpty(rooms): boolean {
  return rooms?.every(room => {
    return room?.tasks?.length === 0 || room?.todos?.length === 0;
  });
}
